import DataTable from "react-data-table-component";
import React, { useState, useEffect } from "react";
import { useVehicleContext } from "../../context/VehicleContext";
import { useNavigate } from "react-router-dom";
import { useLocalization } from "../../context/LocalizationContext";
import getUserRoleFromJWT from "../../shared/helpers/getUserRoleFromJWT";
import { UserRole } from "../../shared/Enums/UserRole";
import { useSelectedDealership } from "../../hooks/useLocalStorage";
const customStyles = {
  table: {
    style: {
      width: "100%",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#f4f4f4",
      color: "#333",
      borderRight: "1px solid #ccc",
      fontSize: "16px",
      fontWeight: 600,
    },
  },
  cells: {
    style: {
      borderRight: "1px solid #eee",
      fontSize: "13px",
    },
  },
  rows: {
    style: {
      minHeight: "45px",
    },
  },
};

const SelectCustomerStep = () => {
  const navigate = useNavigate();
  const [quickSearch, setQuickSearch] = useState("");
  const { t: localization } = useLocalization();
  const ctx = useVehicleContext();
  const { handleSearch, searchResults, onSelectCustomer, showTable } = ctx;
  const [selectedDealershipId] = useSelectedDealership();

  useEffect(() => {
    if (selectedDealershipId) {
      handleSearch(selectedDealershipId);
    }
  }, [selectedDealershipId]);
  const columns = [
    {
      name: localization("customer_name"),
      selector: (row) => row.customerName,
      sortable: true,
    },
    {
      name: localization("address"),
      selector: (row) => row.address1,
      sortable: true,
    },
    {
      name: localization("vehicle"),
      selector: (row) => `${row.year} ${row.makeName} ${row.modelName}`,
      sortable: true,
    },
    {
      name: localization("vin"),
      selector: (row) => row?.vin || "N/A",
      sortable: true,
    },
    {
      name: localization("action"),
      cell: (row) => (
        <button
          className="btn btn-sm btn-success"
          onClick={() => onSelectCustomer(row)}
        >
          {localization("select")}
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <div className="page-title">
        <div className="container-fluid p-0">
          <div className="row">
            <div className="col-md-6 d-flex align-items-center justify-content-start">
              <h1>{localization("step_select_customer")}</h1>
            </div>
            <div className="col-md-6 d-flex align-items-center justify-content-end">
              <div className="d-flex align-items-center gap-2">
                <div style={{ position: "relative", width: "250px" }}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={localization("search")}
                    style={{ paddingRight: "2.5rem" }}
                    value={quickSearch}
                    onChange={(e) => setQuickSearch(e.target.value)}
                  />
                  {quickSearch && (
                    <button
                      type="button"
                      className="btn btn-link p-0 position-absolute"
                      style={{
                        right: "8px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#888",
                        fontSize: "1.2rem",
                        textDecoration: "none",
                      }}
                      onClick={() => setQuickSearch("")}
                      tabIndex={-1}
                      aria-label="Clear search"
                    >
                      <i className="fas fa-times-circle"></i>
                    </button>
                  )}
                </div>
                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  style={{ whiteSpace: "nowrap" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate("/create-customer");
                  }}
                >
                  {localization("new_customer")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }, [quickSearch, localization, navigate, setQuickSearch]);

  return (
    <div className="container-fluid p-0 select-vehicle-content">
      <div className="content form-card d-block">
        <div className="d-flex flex-column align-items-center">
          <div style={{ width: "100%", maxWidth: "" }}>
            {showTable && (
              <>
                <DataTable
                  columns={columns}
                  data={searchResults.filter((c) => {
                    const keyword = quickSearch.toLowerCase();
                    if (!keyword) return true;
                    return (
                      c.customerName?.toLowerCase().includes(keyword) ||
                      c.address1?.toLowerCase().includes(keyword) ||
                      c.vin?.toLowerCase().includes(keyword) ||
                      `${c.year} ${c.makeName} ${c.modelName}`
                        .toLowerCase()
                        .includes(keyword)
                    );
                  })}
                  pagination
                  highlightOnHover
                  striped
                  pointerOnHover
                  noDataComponent={localization("no_record_found")}
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                  responsive
                  customStyles={customStyles}
                />
                <div
                  className="mb-3"
                  style={
                    searchResults.length === 0 ? { marginTop: "32px" } : {}
                  }
                >
                  <button
                    className="btn btn-blue"
                    onClick={() => {
                      const userRole = getUserRoleFromJWT();
                      navigate(
                        userRole === UserRole.DEALER_ADMIN
                          ? "/admin-dashboard"
                          : "/service-desk-dashboard",
                      );
                    }}
                  >
                    {localization("back")}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectCustomerStep;
